import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

import { AvatarClassName, AvatarColor, AvatarSize } from './avatar.types';

import { Skeleton } from '../skeleton';

const AVATAR_SIZE_LOOKUP: { [key in AvatarSize]: AvatarClassName } = {
  xs: 'h-4 w-4 text-xs',
  sm: 'h-8 w-8 text-sm',
  md: 'h-11 w-11 text-xl',
  lg: 'h-16 w-16 text-2xl',
};

const AVATAR_COLOR_LOOKUP: { [key in AvatarColor]: AvatarClassName } = {
  default: 'bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-300',
  text: 'bg-gray-400 dark:bg-gray-500 text-gray-100 dark:text-gray-900',
  primary: 'bg-brand-primary dark:bg-brand-primary-hover text-black dark:text-black',
  none: undefined,
};

type AvatarProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  className?: string;
  color?: AvatarColor;
  size?: AvatarSize;
  loading?: boolean;
};

export function Avatar({
  className,
  children,
  color = 'default',
  size = 'md',
  loading = false,
  ...otherProps
}: PropsWithChildren<AvatarProps>) {
  return (
    <div
      className={classNames(
        'flex relative items-center justify-center flex-shrink-0 leading-none rounded-full overflow-hidden select-none',
        'overflow-ellipsis whitespace-nowrap',
        AVATAR_COLOR_LOOKUP[color],
        AVATAR_SIZE_LOOKUP[size],
        className,
      )}
      {...otherProps}
    >
      {!loading ? children : <Skeleton variant="rectangular" className="w-full h-full" />}
    </div>
  );
}

export default Avatar;
